var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "slide",
    attrs: {
      "id": "slide"
    }
  }, [_c('div', {
    staticClass: "slide-show"
  }, _vm._l((_vm.slides), function(slide) {
    return _c('div', {
      staticClass: "slide-item"
    }, [_c('div', {
      staticClass: "slide-text row"
    }, [_c('div', {
      staticClass: "col-md-6 offset-md-3 justify-content-center"
    }, [_c('h2', {
      staticClass: "slide-title"
    }, [_vm._v(_vm._s(slide.title))]), _c('p', [_vm._v(_vm._s(slide.text))]), _c('div', {
      staticClass: "row justify-content-center button-container"
    })])])])
  })), _c('ul', {
    staticClass: "slide-indicator"
  }, _vm._l((_vm.indicators), function(indicator) {
    return _c('li', {
      staticClass: "indicator-item"
    }, [_c('div', {
      staticClass: "line",
      class: indicator,
      attrs: {
        "rol": "low-indicator"
      }
    })])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-574e444f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/src/components/Slide.vue
// module id = 45
// module chunks = 0